import {Injectable} from '@angular/core';
import {StoreService} from '../modules/akita-mimic/services/store.service';
import {PermissionState} from '../modules/akita-mimic/models/store-states/permission-state.model';

@Injectable({ providedIn: 'root' })
export class PermissionStore extends StoreService<PermissionState> {

    public constructor() {
        super('permission', {
            vaultPermissions: {},
            userGroupPermissions: {},
            documentPermissions: {},
            checkedOutDocumentPermissions: {},
            trashedDocumentPermissions: {},
            documentTypeCategoryPermissions: {}
        });
    }
}
